'use client';

import { Button } from '@ahafood/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ahafood/ui/components/dialog';
import { Sheet, SheetContent, SheetTitle } from '@ahafood/ui/components/sheet';
import { useState } from 'react';
import { useIsMobile } from '@/lib/is-mobile';
import { useNewAuth } from '@/providers/new-auth-provider';

interface NewLoginDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location?: string;
  redirectTo?: string;
}

export function NewLoginDialog({
  open,
  onOpenChange,
  redirectTo,
}: NewLoginDialogProps) {
  const isMobile = useIsMobile();
  const { login } = useNewAuth();
  const [busy, setBusy] = useState(false);

  const handleLogin = () => {
    if (busy) return;
    setBusy(true);
    void login(redirectTo);
  };

  const content = (
    <div className="flex flex-col gap-3 px-1 pt-2 pb-1">
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-bold text-neutral-90">
          Đăng nhập AhaFood
        </h2>
        <p className="text-sm text-neutral-60">
          Đăng nhập bằng tài khoản Ahamove để tiếp tục.
        </p>
      </div>
      <Button
        onClick={handleLogin}
        disabled={busy}
        className="w-full font-bold mt-1"
      >
        {busy ? 'Đang chuyển hướng...' : 'Đăng nhập với Ahamove'}
      </Button>
    </div>
  );

  if (isMobile) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="bottom" className="rounded-t-2xl p-4">
          <SheetTitle className="sr-only">Đăng nhập</SheetTitle>
          {content}
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs p-5">
        <DialogTitle className="sr-only">Đăng nhập</DialogTitle>
        {content}
      </DialogContent>
    </Dialog>
  );
}
